module.exports = __webpack_public_path__ + "img/img5zhCn.dc47ee3a.png";